export const confidenceImageUrls = [
  {
    medium:
      'https://assets.riparide.com/landing_pages/list-with-us/confidence/1/medium.jpg',
    large:
      'https://assets.riparide.com/landing_pages/list-with-us/confidence/1/large.jpg',
  },
  {
    medium:
      'https://assets.riparide.com/landing_pages/list-with-us/confidence/8/medium.jpg',
    large:
      'https://assets.riparide.com/landing_pages/list-with-us/confidence/8/large.jpg',
  },
  {
    medium:
      'https://assets.riparide.com/landing_pages/list-with-us/confidence/6/medium.jpg',
    large:
      'https://assets.riparide.com/landing_pages/list-with-us/confidence/6/large.jpg',
  },
  {
    medium:
      'https://assets.riparide.com/landing_pages/list-with-us/confidence/3/medium.jpg',
    large:
      'https://assets.riparide.com/landing_pages/list-with-us/confidence/3/large.jpg',
  },
  {
    medium:
      'https://assets.riparide.com/landing_pages/list-with-us/confidence/4/medium.jpg',
    large:
      'https://assets.riparide.com/landing_pages/list-with-us/confidence/4/large.jpg',
  },

  {
    medium:
      'https://assets.riparide.com/landing_pages/list-with-us/confidence/2/medium.jpg',
    large:
      'https://assets.riparide.com/landing_pages/list-with-us/confidence/2/large.jpg',
  },
  {
    medium:
      'https://assets.riparide.com/landing_pages/list-with-us/confidence/5/medium.jpg',
    large:
      'https://assets.riparide.com/landing_pages/list-with-us/confidence/5/large.jpg',
  },
  {
    medium:
      'https://assets.riparide.com/landing_pages/list-with-us/confidence/7/medium.jpg',
    large:
      'https://assets.riparide.com/landing_pages/list-with-us/confidence/7/large.jpg',
  },
]

export const hostWithConfidenceInfo = [
  {
    heading: 'Stand out with Stories',
    text:
      'Riparide Stories bring your listing to life, drive more bookings and get higher search results. Winner winner!',
  },
  {
    heading: 'Attract like-minded guests',
    text:
      'Riparide guests are looking for fulfilling moments in the great outdoors, not a luxury hotel experience. And we wouldn’t have it any other way.',
  },
  {
    heading: 'Get local support',
    text:
      'Our Host Support Team provide you with a very personable support experience along your journey. We’re real humans, not bots! You can speak to us via live chat, email and phone in your timezone.',
  },
  {
    heading: 'Sync up!',
    text:
      'Using other booking platforms? You can easily sync your Riparide calendar with other sites and some channel managers to avoid double bookings.',
  },
  {
    heading: 'Get paid on time, every time',
    text:
      'No waiting, that’s a Riparide promise. We manage secure payments and payouts in your currency using Stripe, to ensure you get paid on time.',
  },
  {
    heading: 'Join the mission',
    text:
      'We’re here to inspire people to get into nature and chase those fulfilling moments. You’ll be having a positive impact on people’s lives.',
  },
]
